exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ai-sight-privacypolicy-js": () => import("./../../../src/pages/ai-sight_privacypolicy.js" /* webpackChunkName: "component---src-pages-ai-sight-privacypolicy-js" */),
  "component---src-pages-doggopediaprivacypolicy-js": () => import("./../../../src/pages/doggopediaprivacypolicy.js" /* webpackChunkName: "component---src-pages-doggopediaprivacypolicy-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

